import { de, pt, es, fr, nl, it, ko, ja, vi, zhCN, ar} from 'date-fns/locale'

export default {
  de, pt, es, fr, nl, it, ko, ja, vi, zhCN, ar
};